/**
 * Takes in the name of the cookie and returns null if the key value pair
 * does not exist or the value of the cookie if it does exist.
 */
export const getCookie = (name) => {
  if (typeof window === "undefined") {
    return "";
  }
  const prefix = `${name}=`;
  let begin = document.cookie.indexOf(`; ${prefix}`);

  // cookie key/value pair is not the 2nd or further on.
  if (begin === -1) {
    begin = document.cookie.indexOf(prefix);
    if (begin !== 0) {
      return null;
    }
  } else {
    // skip past the "; " separator.
    begin += 2;
  }
  let end = document.cookie.indexOf(";", begin);

  // the end of the cookie does not exist?
  if (end === -1) {
    end = document.cookie.length;
  }

  return decodeURI(document.cookie.substring(begin + prefix.length, end));
};
